<template>
  <select-input name="hotel"
                fa-class="hotel"
                :label="label"
                :placeholder="placeholder"
                :options="options"
                class="hotel"
                v-model="val"
                :required="required"
                :ref="type"
  />
</template>

<script>
import selectInput from '@/components/frontoffice/form/baseInput/select'
import wrapperFormMethods from '@/components/frontoffice/mixins/wrapperFormMethods'

export default {
  components: {
    selectInput
  },
  mixins: [wrapperFormMethods],
  data () {
    return {
      label: 'group.form.hotel.label',
      placeholder: 'group.form.hotel.placeholder',
      options: [
        { value: 'poi', text: 'Test1' },
        { value: 'aa', text: 'Test2' },
        { value: 'bb', text: 'Test3' },
        { value: 'cc', text: 'Test4' }
      ],
      val: this.value,
      type: 'select'
    }
  },
  props: {
    value: {
      type: String
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    val (newVal, oldVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
